import React, { useState, useEffect, useCallback } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { getUserInvestmentDetails } from "../../redux/actions/adminActions";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import Loader from "../../components/Loader/Loader";
import "../../components/common/css/datatable.scss";
import PageShell from "../../components/layout/PageShell";
import PageHead from "../../components/layout/PageHead";

const DesignationReportDetails = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [reportDetailsLevel, setReportDetailsLevel] = useState(false);
  const params = useParams();
  const [pageState, setPageState] = useState({
    data: [],
    total: 0,
    page: 1,
    pageSize: 9,
  });

  const userManagerColumns = [
    { field: "id", headerName: "ID", width: 60 },

    {
      field: "firstname",
      headerName: "User Name",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        const userFullName =
          params?.row?.firstname.charAt(0).toUpperCase() +
          params?.row?.firstname.slice(1) +
          " " +
          params?.row?.lastname.charAt(0).toUpperCase() +
          params?.row?.lastname.slice(1);
        return (
          <>
            <div className="rowitem">{userFullName}</div>
          </>
        );
      },
    },
    {
      field: "country_name",
      headerName: "Country",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "designation",
      headerName: "Designation",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "managerFirstname",
      headerName: "Reporting",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "createdAt",
      headerName: "Joined At",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const d = new Date(params?.row?.createdAt);
        return (
          <>
            <div className="rowitem">{d.toDateString()}</div>
          </>
        );
      },
    },
    {
      field: "updatedAt",
      headerName: "Last Updated",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const d = new Date(params?.row?.updatedAt);
        return (
          <>
            <div className="rowitem">{d.toDateString()}</div>
          </>
        );
      },
    },
  ];
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/users/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                <RemoveRedEyeOutlinedIcon />
              </div>
            </Link>
          </div>
        );
      },
    },
  ];

  const userConsultantColumns = [
    { field: "id", headerName: "ID", width: 60 },

    {
      field: "firstname",
      headerName: "User Name",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        const userFullName =
          // params?.firstname + " " + params?.lastname;
          params?.row?.firstname.charAt(0).toUpperCase() +
          params?.row?.firstname.slice(1) +
          " " +
          params?.row?.lastname.charAt(0).toUpperCase() +
          params?.row?.lastname.slice(1);
        return (
          <>
            <div className="rowitem">{userFullName}</div>
          </>
        );
      },
    },
    {
      field: "country_name",
      headerName: "Country",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "designation",
      headerName: "Designation",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "managerFirstname",
      headerName: "Reporting",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "createdAt",
      headerName: "Joined At",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const d = new Date(params?.row?.createdAt);
        return (
          <>
            <div className="rowitem">{d.toDateString()}</div>
          </>
        );
      },
    },
    {
      field: "updatedAt",
      headerName: "Last Updated",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const d = new Date(params?.row?.updatedAt);
        return (
          <>
            <div className="rowitem">{d.toDateString()}</div>
          </>
        );
      },
    },
  ];

  const userColumns = [
    { field: "id", headerName: "ID", width: 60 },

    {
      field: "firstname",
      headerName: "User Name",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        const userFullName =
          params?.row?.firstname.charAt(0).toUpperCase() +
          params?.row?.firstname.slice(1) +
          " " +
          params?.row?.lastname.charAt(0).toUpperCase() +
          params?.row?.lastname.slice(1);
        return (
          <>
            <div className="rowitem">{userFullName}</div>
          </>
        );
      },
    },
    {
      field: "country_name",
      headerName: "Country",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "designation",
      headerName: "Designation",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "managerFirstname",
      headerName: "Reporting",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "createdAt",
      headerName: "Joined At",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const d = new Date(params?.row?.createdAt);
        return (
          <>
            <div className="rowitem">{d.toDateString()}</div>
          </>
        );
      },
    },
    {
      field: "updatedAt",
      headerName: "Last Updated",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const d = new Date(params?.row?.updatedAt);
        return (
          <>
            <div className="rowitem">{d.toDateString()}</div>
          </>
        );
      },
    },
  ];

  const requestColumn = [
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/designation-report/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                <RemoveRedEyeOutlinedIcon
                  onClick={() => viewTeam(params?.row?.id)}
                />
              </div>
            </Link>
          </div>
        );
      },
    },
  ];

  const requestManagerColumn = [
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/designation-report/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                <RemoveRedEyeOutlinedIcon
                  onClick={() => viewTeam(params?.row?.id)}
                />
              </div>
            </Link>
          </div>
        );
      },
    },
  ];

  const viewTeam = (id) => {
    let token = localStorage.getItem("accessToken");
    setLoading(true);

    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "getFollowersByManagerId",
      headers: {
        "x-access-token": token,
      },
      data: {
        manager_id: id,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setPageState((old) => ({
          ...old,
          data: response.data.data,
          total: response.data.data.count,
        }));
        setReportDetailsLevel(response.data.data);
        // window.location.reload(true);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };


  useEffect(() => {
    fetchFollowersDetails();
  }, []);
  const fetchFollowersDetails = () => {
    let token = localStorage.getItem("accessToken");
    setLoading(true);

    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "getFollowersByManagerId",
      headers: {
        "x-access-token": token,
      },
      data: {
        manager_id: params?.managerId,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setPageState((old) => ({
          ...old,
          data: response.data.data,
          total: response.data.data.count,
        }));
        setReportDetailsLevel(response.data.data);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  return (
    <PageShell><PageHead title="Designation report detail" /><div className="list">
      <div className="listContainer">
        <Loader isLoading={loading} />

        {pageState.data.length > 0 ? (
          <div className="datatable">
            <hr className="custom-divider"></hr>
            <div className="datatableTitle manageUser-top">
              <h5
                className="h5Title"
                style={{ textAlign: "left", marginBottom: "0" }}
              >
                Team - Reports to{" "}
                {pageState.data?.[0]?.managerFirstname.charAt(0).toUpperCase() +
                  pageState.data?.[0]?.managerFirstname.slice(1) +
                  " " +
                  pageState.data?.[0]?.managerLastname.charAt(0).toUpperCase() +
                  pageState.data?.[0]?.managerLastname.slice(1)}
              </h5>
            </div>
            <div className="designationReport-section">
              <h5 className="designationlevel-text">
                Level 2 Team Members - VPs
              </h5>

              <DataGrid
                className="datagrid"
                autoHeight
                rows={pageState.data.filter((item) => item.level == 2)}
                rowCount={pageState.total}
                rowsPerPageOptions={[10, 30, 50, 70, 100]}
                pagination
                columns={userColumns.concat(requestColumn)}
              />
              
 
            </div>
            <div className="designationReport-section">
              <h5 className="designationlevel-text">
                Level 3 Team Members - Regional Managers
              </h5>

             
              <DataGrid
                className="datagrid"
                autoHeight
                rows={pageState.data.filter((item) => item.level == 3)}
                rowCount={pageState.total}
                rowsPerPageOptions={[10, 30, 50, 70, 100]}
                pagination
                columns={userManagerColumns.concat(requestManagerColumn)}
              />
              
            </div>
            <div className="designationReport-section">
              <h5 className="designationlevel-text">
                Level 4 Team Members - Consultant
              </h5>

              <DataGrid
                className="datagrid"
                autoHeight
                rows={pageState.data.filter((item) => item.level == 4)}
                rowCount={pageState.total}
                rowsPerPageOptions={[10, 30, 50, 70, 100]}
                pagination
                columns={userConsultantColumns.concat(actionColumn)}
              />
  
            </div>
            <div className="designationReport-section">
              <h5 className="designationlevel-text">
                Level 5 Team Members - Referral
              </h5>

              <DataGrid
                className="datagrid"
                autoHeight
                rows={pageState.data.filter((item) => item.level == 5)}
                rowCount={pageState.total}
                rowsPerPageOptions={[10, 30, 50, 70, 100]}
                pagination
                columns={userConsultantColumns.concat(actionColumn)}
              />
  
            </div>
          </div>
        ) : (
          "No Data Found"
        )}
      </div>
    </div></PageShell>
  );
};

export default DesignationReportDetails;
